import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { PageTitle } from '../../../rbts/layout/core';

const API_URL = process.env.REACT_APP_API;

const initialValues = {
  monto_limite: '',
};

const validationSchema = Yup.object().shape({
  monto_limite: Yup.number()
    .required('El monto límite es requerido')
    .min(0, 'El monto debe ser mayor o igual a 0')
    .typeError('Debe ser un número válido'),
});

export function ConfiguracionRetiro() {
  const [loading, setLoading] = useState(false);
  const [initialLoading, setInitialLoading] = useState(true);

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: async (values, { setSubmitting }) => {
      setLoading(true);
      try {
        await axios.put(`${API_URL}retiro/monto-limite`, {
          monto_limite: parseFloat(values.monto_limite),
        });
        toast.success('Límite de retiro actualizado correctamente', {
          position: 'top-right',
          autoClose: 3000,
        });
      } catch (err: any) {
        toast.error(err.response?.data?.message || 'Error al guardar el límite', {
          position: 'top-right',
          autoClose: 4000,
        });
      } finally {
        setLoading(false);
        setSubmitting(false);
      }
    },
  });

  const loadMonto = async () => {
    try {
      const response = await axios.get(`${API_URL}retiro/monto-limite`);
      const { monto_limite } = response.data.doc.data;
      formik.setValues({ monto_limite: monto_limite.toString() });
    } catch (err) {
      toast.error('Error al cargar la configuración', { position: 'top-right' });
    } finally {
      setInitialLoading(false);
    }
  };

  useEffect(() => {
    loadMonto();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <PageTitle>Límites de Retiro Global</PageTitle>

      <div className="card card-custom">
        <div className="card-header border-0 pt-5">
          <h3 className="card-title align-items-start flex-column">
            <span className="card-label fw-bolder fs-3 mb-1">
              Configuración de Alertas
            </span>
            <span className="text-muted mt-1 fw-bold fs-7">
              Defina el monto límite de venta acumulada que mostrará alerta en las cajas
            </span>
          </h3>
        </div>
        <div className="card-body py-3">
          {initialLoading ? (
            <div className="d-flex justify-content-center p-10">
              <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
            </div>
          ) : (
            <form onSubmit={formik.handleSubmit} className="form w-100" noValidate>
              <div className="row mb-6">
                <label className="col-lg-4 col-form-label required fw-bold fs-6">
                  Monto Límite Global ($)
                </label>
                <div className="col-lg-8 fv-row">
                  <input
                    type="number"
                    step="0.01"
                    className={`form-control form-control-lg form-control-solid ${
                      formik.touched.monto_limite && formik.errors.monto_limite
                        ? 'is-invalid'
                        : ''
                    }`}
                    placeholder="Ejemplo: 1000.00"
                    {...formik.getFieldProps('monto_limite')}
                  />
                  {formik.touched.monto_limite && formik.errors.monto_limite && (
                    <div className="fv-plugins-message-container">
                      <div className="fv-help-block text-danger mt-2">
                        {formik.errors.monto_limite}
                      </div>
                    </div>
                  )}
                  <div className="text-muted mt-2">
                    Este valor aplicará para TODAS las cajas. Si la venta acumulada supera este monto, aparecerá un aviso en la App.
                  </div>
                </div>
              </div>

              <div className="card-footer d-flex justify-content-end py-6 px-9">
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={loading || !formik.isValid}
                >
                  {!loading && 'Guardar Cambios'}
                  {loading && (
                    <span className="indicator-progress" style={{ display: 'block' }}>
                      Guardando...
                      <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                    </span>
                  )}
                </button>
              </div>
            </form>
          )}
        </div>
      </div>
    </>
  );
}
